;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('NotificationCentralController', NotificationCentralController)

  /* @ngInject */
  function NotificationCentralController ($scope, $rootScope, $timeout, $state, $element, NotificationsService, NotificationsCentralService) {
    $scope.currentTop = 12
    $scope.notifications = {
      all: [],
      new: [],
      currentSkip: 0,
      notificationsCount: 0,
      loading: true,
      showLoadMore: false
    }

    const api = {
      _getNotifications,
      _sucessCallbackGetNotifications,
      _addInfiniteScroll,
      _handleClickAway
    }

    this.getApi = () => api
    activate()

    function activate () {
      document.addEventListener('click', api._handleClickAway)
    }

    const deregisterLoadInitialNotifications = $scope.$on('loadInitialNotifications', function (event, reloadNotifications) {
      if (!$scope.notifications.all.length || reloadNotifications) {
        $scope.notifications.currentSkip = 0
        api._getNotifications($scope.currentTop, 0, $scope.notifications, reloadNotifications).then((notificationTab) => {
          $timeout(() => {
            api._addInfiniteScroll(jQuery('.ui.tab[data-tab="all"]'), notificationTab)
          }, 150, false)
        })
      }
    })

    $scope.$on('$destroy', function () {
      deregisterLoadInitialNotifications()
      document.removeEventListener('click', api._handleClickAway)
    })

    function _handleClickAway (event) {
      const isNotificationElement = $element[0].contains(event.target)
      const isOpen = NotificationsCentralService.isOpen()

      if (!isNotificationElement && isOpen) {
        $scope.closeNotificationsCentral()
      }
    }

    $scope.closeNotificationsCentral = function () {
      NotificationsCentralService.close()
    }

    $scope.loadMoreNotifications = function (notificationTab) {
      notificationTab.currentSkip += 1
      api._getNotifications($scope.currentTop, notificationTab.currentSkip * $scope.currentTop, notificationTab)
    }

    $scope.configureNotifications = function () {
      NotificationsCentralService.close()
      $state.go('profile.notifications')
    }

    $scope.markAllRead = (notificationTab) => {
      notificationTab.currentSkip = 0
      notificationTab.all = []
      notificationTab.new = []

      NotificationsService.readAllNotifications().then(() => {
        $rootScope.$broadcast('reloadUnreadNotifications')
        api._getNotifications($scope.currentTop, 0, notificationTab)
      })
    }

    function _getNotifications (currentTop, currentSkip, notificationTab, reloadNotifications) {
      currentTop = currentTop || 8
      currentSkip = currentSkip || 0

      notificationTab.loading = true
      return NotificationsService.getNotifications(currentTop, currentSkip)
        .then(response => api._sucessCallbackGetNotifications(response, notificationTab, reloadNotifications))
    }

    function _appendCustomerCompany (notifications) {
      return notifications.map(notification => {
        const from = NotificationsCentralService.getNotificationFrom(notification)
        const result = $rootScope.userCompanies.find(company => {
          if (notification[from]) {
            return company.customerCompanyId === notification[from].customerCompanyId
          }
        })
        if (result) {
          notification.customerCompany = {
            id: result.customerCompanyId,
            formattedName: result.formattedName
          }
        } else {
          notification.customerCompany = $rootScope.oUserCompany
        }

        return notification
      })
    }

    function _sucessCallbackGetNotifications (response, notificationTab, reloadNotifications) {
      const results = _appendCustomerCompany(response.d.results)

      if (reloadNotifications) {
        notificationTab.new = []
        notificationTab.all = []
      }

      const newNotifications = results.filter(item => item.isNew)
      const oldNotifications = results.filter(item => {
        const sameId = notificationTab.all.find(notif => notif.id === item.id)

        if (!item.isNew && !sameId) {
          return item
        }
      })

      notificationTab.new = notificationTab.new.concat(newNotifications)
      notificationTab.all = notificationTab.all.concat(oldNotifications)

      notificationTab.notificationsCount = response.d.__count
      notificationTab.showLoadMore = notificationTab.all.length + notificationTab.new.length < notificationTab.notificationsCount
      $timeout(() => {
        notificationTab.loading = false
        jQuery('.ui.tab[data-tab="all"]').scrollTop(jQuery('.ui.tab[data-tab="all"]').scrollTop() - 5)
        if (!$scope.$$phase) {
          $scope.$digest()
        }
      }, 500, false)
      return Promise.resolve(notificationTab)
    }

    function _addInfiniteScroll (element, notificationTab) {
      if (!notificationTab.showLoadMore) {
        return
      }

      jQuery(element).scroll(function () {
        if (!notificationTab.loading && notificationTab.showLoadMore && $(this).scrollTop() + $(this).height() >= $(this).find('.inner-scroll-div').height()) {
          notificationTab.loading = true
          $scope.loadMoreNotifications(notificationTab)
        }
      })
    }
  }
})()
